import SEOHead from '@/components/base/SEOHead';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '第一版主——论坛版块管理核心指南',
  description: '深度解析第一版主的职责、权限、任命流程与管理技巧，帮助论坛运营者与版主候选人全面掌握第一版主的核心能力，打造高质量社区版块。',
  url: 'https://diyibanzhu.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '第一版主',
    url: 'https://diyibanzhu.com/',
  },
  about: {
    '@type': 'Thing',
    name: '第一版主',
    description: '论坛社区中拥有最高版块管理权限的核心角色，负责版块内容管理、团队协调、规则制定与战略规划。',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '什么是第一版主？与普通版主有什么区别？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '第一版主是论坛社区中拥有最高版块管理权限的核心角色，通常是某个版块的管理团队负责人。与普通版主相比，第一版主不仅负责日常内容管理，还承担团队管理、规则制定和战略规划等更高层级的职责。',
      },
    },
    {
      '@type': 'Question',
      name: '成为第一版主需要满足哪些条件？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '成为第一版主通常需要满足以下条件：在论坛注册时间超过一年、担任版主或副版主不少于六个月、在目标版块有持续的活跃贡献、无重大违规记录。此外，还需要展示出优秀的内容判断力、团队管理能力、沟通协调能力和战略思维。',
      },
    },
    {
      '@type': 'Question',
      name: '第一版主的任命流程是怎样的？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '第一版主的任命通常经历以下流程：内部推荐或自荐 → 资格审查 → 综合评估 → 公示（接受社区反馈，通常7-14天）→ 正式任命。部分论坛还会设置3个月的试用期。',
      },
    },
    {
      '@type': 'Question',
      name: '第一版主有哪些核心权限？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '第一版主的核心权限包括：帖子管理权限（置顶、精华、删除、移动等）、用户管理权限（禁言、封禁、用户组调整等）、版块设置权限（规则修改、分类调整、积分策略等）、团队管理权限（版主任免、权限分配等）以及数据查看权限。',
      },
    },
    {
      '@type': 'Question',
      name: '如何从普通版主晋升为第一版主？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '从普通版主晋升为第一版主需要一个循序渐进的成长过程。关键路径包括：持续产出高质量的管理成果、主动承担更多责任、培养团队管理能力和战略思维、建立良好的社区口碑和团队认可度。晋升通常需要1-3年的积累。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="第一版主——论坛版块管理核心指南 | 版主职责·权限·任命全方位解析"
        description="「第一版主」是论坛社区中拥有最高版块管理权限的核心角色。深度解析第一版主的职责权限、任命流程与管理技巧，帮助论坛运营者全面掌握版主核心能力，打造高质量社区版块。"
        keywords="第一版主,第一版主职责,第一版主权限,论坛版主管理,版主任命流程,社区版块管理,论坛运营技巧,版主晋升指南"
        canonicalUrl="https://diyibanzhu.com/"
        ogTitle="第一版主——论坛版块管理核心指南"
        ogDescription="深度解析第一版主的职责、权限、任命流程与管理技巧，帮助论坛运营者打造高质量社区版块。"
        ogUrl="https://diyibanzhu.com/"
        jsonLdScripts={[homepageJsonLd, faqJsonLd]}
      />
      <Hero />
      <CategoryGrid />
      <FeaturedArticles />
      <FAQSection />
      <CTASection />
    </>
  );
}